import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TkPopDetailWrappringDialog from "../dialogTypes/TkPopDetailWrappringDialog";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import defineConf from "../../config/defineConf";

function TkPopWrappingCreateButton(props) {

    const { t } = useTranslation();

    const { id, grid, mode, refresh, onSuccess, onSelectMst, createButtonName, customizeErrorMsgCallback, shapeType, ...others } = props;

    const [open, setOpen] = useState(false);
    const [schema, setSchema] = useState(false);
    
    useEffect(() => {

        let schema = {

            name: "TkPopProductManageDetail",
            type: "BASE TABLE",
            searchAll: false,
            formGroups: [
                "disabled",
                "wrappingInput",
                "commonInput"
            ],

            columns: [
                { 
                    name: "planId", 
                    formGroup: 0,
                    formOrder : 0,
                    disabled : true,
                    hideInForm: true,
                    formItemType : "text",
                },
                { 
                    name: "processCode", 
                    formGroup: 0,
                    formOrder : 10,
                    disabled : true,
                    hideInForm: true,
                    formItemType : "text",
                },
                { 
                    name: "wpShapeType", 
                    formGroup: 0,
                    formOrder : 20,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "workTime", 
                    formGroup: 2,
                    formOrder : 80,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "autocompleteSolo",
                    codeInfo: {
                        tableName: "TimeToSecond",
                        nameColumn: ["timeName"],
                        valueColumn: "second",
                    }
                },
                { 
                    name: "workers",
                    formGroup: 2,
                    formOrder: 90,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "multipleAutocomplete",

                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    }
                },
                { 
                    name: "isRepair", 
                    formGroup: 2,
                    formOrder : 100,
                    disabled : false,
                    hideInForm : false,
                    formItemType : "checkbox",
                },
                { 
                    name: "size", 
                    formGroup: 2,
                    formOrder : 110,
                    disabled : false,
                    hideInForm : false,
                    formItemType: "select",

                    selectItems: [
                        {
                            name: "selectItems.size.big",
                            value: defineConf.sizeType.BIG
                        },
                        {
                            name: "selectItems.size.small",
                            value: defineConf.sizeType.SMALL
                        },
                        {
                            name: "selectItems.size.common",
                            value: defineConf.sizeType.COMMON
                        },
                    ],

                    defaultValue: defineConf.sizeType.SMALL,
                },
            ]

        };

        if(shapeType === "VD") {

            schema.columns.push (

                { 
                    name: "wpProduct", 
                    formGroup: 0,
                    formOrder : 30,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpDivision", 
                    formGroup: 0,
                    formOrder : 40,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpProductName", 
                    formGroup: 0,
                    formOrder : 50,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpSpec", 
                    formGroup: 0,
                    formOrder : 60,
                    disabled : true,
                    required: true,
                    formItemType: "text",
                },
                { 
                    name: "wpInch", 
                    formGroup: 1,
                    formOrder : 70,
                    required: true,
                    formItemType : "number",
                    validation : {
                        msg: "error.numberRequired",
                        type: "regexp",
                        value: "^[1-9][0-9]*$",
                    }
                },

            )

        } else {

            schema.columns.push(

                { 
                    name: "wpDivision", 
                    formGroup: 0,
                    formOrder : 30,
                    disabled : true,
                    required: true,
                    formItemType : "text",
                },
                { 
                    name: "wpArea", 
                    formGroup: 1,
                    formOrder : 40,
                    required: true,
                    formItemType : "number",
                    validation : {
                        msg: "error.numberRequired",
                        type: "regexp",
                        value: "^[1-9][0-9]*$",
                    }
                },
                { 
                    name: "wpSpec", 
                    formGroup: 1,
                    formOrder : 50,
                    required: true,
                    formItemType: "select",
                    sortByValue: true,
    
                    selectItems: [
                        {
                            name: "selectItems.wpSpec.lowUnitPrice",
                            value: defineConf.wpSpec.lowUnitPrice
                        },
                        {
                            name: "selectItems.wpSpec.mediumUnitPrice",
                            value: defineConf.wpSpec.mediumUnitPrice
                        },
                        {
                            name: "selectItems.wpSpec.highUnitPrice",
                            value: defineConf.wpSpec.highUnitPrice
                        },
                    ],
                },

            )

        }

        setSchema(schema);

    }, [shapeType]);

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        if(refresh) {

            refresh.refresh();

        }

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={createButtonName} {...others} />
            <TkPopDetailWrappringDialog
                id={id + "create-dialog"}
                mode={mode}
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${shapeType === "VD" ? "TkPopProductManageDetailWrappingVD" : "TkPopProductManageDetailWrapping"}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSelectMst={onSelectMst}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                shapeType={shapeType}
            />
        </>

    );
}

export default TkPopWrappingCreateButton;

